import { FC } from 'react';
import { ImagePreviewPropTypes } from './ImageModalPropTypes';

const ImagePreview: FC<ImagePreviewPropTypes> = (props) => {
   const { src = '' } = props;

   return <img src={src} alt="image-preview" />;
};

export default ImagePreview;